import {
    CampaignType,
    CheckupLengthChoices,
    CheckupTypeChoices,
    CompanyAddressType,
    CompanyType,
    ContactPersonType,
    CostCenterType,
    CustomerAddressType,
    CustomerType,
    DocumentCategoryType,
    DocumentsDocumentCategoryTypeChoices,
    DocumentType,
    DocumentVersionType,
    ExposureType,
    FitnessTestDeviceType,
    FitnesstestsFitnessTestDeviceDeviceTypeChoices,
    Functionality,
    HealthCheckConfigurationType,
    HealthCheckTypeChoices,
    InsuranceCompanyType,
    InsurancesInsuranceInsuranceTypeChoices,
    InsuranceType,
    InvoiceInterfaceType,
    LaboratoryChoices,
    LaboratorySupplierType,
    LanguageEnum,
    NodeGroupType,
    NodeType,
    OrganizationsContactPersonContactTypeChoices,
    OrganizationsCustomerEntrepreneurInsuranceTypeChoices,
    OrganizationsCustomerInvoicingMethodChoices,
    ProfessionalGroupType,
    ProfileType,
    QuestionsQuestionAnswerTypeChoices,
    QuestionType,
    SalescatalogsSalesCatalogStateChoices,
    SalesCatalogType,
    UserType,
    ViewsViewViewTypeChoices,
    ViewType,
    ViewViewTypeChoices,
} from "types/graphql";
import { DEFAULT_COUNTRY, ID_EMPTY } from "Utils/constants";

export const UserEmpty: UserType = {
    tasksSubjectUser: [],
    privacyPolicyAcknowledgments: [],
    privacyPolicyAcknowledgmentsRecorded: [],
    hasValidEmploymentRelationship: false,
    relatedCustomerHasValidContract: false,
    id: ID_EMPTY,
    firstName: "",
    homeTown: "",
    billingPeriods: [],
    country: DEFAULT_COUNTRY,
    email: "",
    isActive: false,
    isHealthcareWorker: false,
    isStaff: false,
    isSupplier: false,
    nationalIdKnown: false,
    password: "",
    phoneNumber: "",
    phoneNumberJob: "",
    address: "",
    postCode: "",
    city: "",
    language: LanguageEnum.Fi,
    dateJoined: "",
    laboratorytestSet: [],
    healthCheckInformation: {},
    lastName: "",
    rolesCompany: [],
    supervisorSubstitute: null,
    supervisorSubstituteEndDate: null,
    supervisorSubstituteStartDate: null,
    surveyAnswers: [],
    titletemplates: [],
    uuid: "",
    idAcute: "",
    views: [],
    campaignSurveys: [],
    createdAt: "",
    createdCampaigns: [],
    rolesCustomer: [],
    rolesCorporate: [],
    documentversionSet: [],
    invoicepurchaseSet: [],
    invoicepurchasecommentSet: [],
    healthcareteams: [],
    acknowledgments: [],
    employeeAcknowledgments: [],
    documentSet: [],
    employeeGroup: null,
    isEntrepreneurWithoutHealthcareUsage: false,
    benefitsRestrictionReason: null,
    benefitsRestrictedUntil: null,
    hasExposure: false,
    jobTitle: "",
    contactPersons: [],
    responsibleDoctorCustomers: [],
    responsibleNurseCustomers: [],
    insurances: [],
    directSubordinates: [],
    employmentInformation: [],
    salescontractversionSet: [],
    logacuteusersyncSet: [],
    acceptedSickLeaves: [],
    handledSickLeaves: [],
    sickLeaveHandlerRoles: [],
    sickLeaves: [],
    substituteSupervisors: [],
    paymentcommitmentSet: [],
    deletedUsers: [],
    isSupervisor: false,
    suitabilityStatements: [],
    unmatchedCalendarBookings: [],
};

export const CompanyEmpty: CompanyType = {
    id: ID_EMPTY,
    name: "",
    businessId: "",
    phone: "",
    isPrimary: false,
    addresses: [],
    companyRoles: [],
    usersCompany: [],
    customerSet: [],
    profileSet: [],
    campaigns: [],
    documentcategorySet: [],
    invoicepurchaseSet: [],
    healthcareteams: [],
    costcenterSet: [],
    createdAt: "",
};

export const CustomerEmpty: CustomerType = {
    id: ID_EMPTY,
    sickLeaveHandlers: [],
    taskSet: [],
    company: CompanyEmpty,
    billingPeriods: [],
    name: "",
    fennoaCustomerNo: "",
    marketingName: "",
    industryCode: "",
    industryName: "",
    phone: "",
    businessId: "",
    idAcute: "",
    eInvoicingAddress: "",
    eInvoicingOperator: "",
    invoicingEmail: "",
    invoicingMethod: OrganizationsCustomerInvoicingMethodChoices.EInvoice,
    invoicingAddressStreetAddress: "",
    invoicingAddressPostCode: "",
    invoicingAddressCity: "",
    acknowledgments: [],
    attachmentAddressStreetAddress: "",
    attachmentAddressPostCode: "",
    attachmentAddressCity: "",
    attachmentAddressEmail: "",
    addresses: [],
    contracts: [],
    customerRoles: [],
    profileSet: [],
    usersCustomer: [],
    documentSet: [],
    invoicesaleSet: [],
    contactPersons: [],
    paymentcommitmentpurchaseSet: [],
    descriptionOfOperations: "",
    descriptionOfOrganization: "",
    descriptionOfStaff: "",
    occupationalHealthNeeds: "",
    occupationalSafetyNeeds: "",
    iban: "",
    bic: "",
    entrepreneurInsuranceType:
        OrganizationsCustomerEntrepreneurInsuranceTypeChoices.Yel,
    taxFreeBenefitsInstructionsGiven: false,
    insurances: [],
    createdAt: "",
    departments: [],
    employeegroupSet: [],
    costcenterSet: [],
    actionplanSet: [],
};

export const CustomerAddressEmpty: CustomerAddressType = {
    id: ID_EMPTY,
    customer: CustomerEmpty,
    isPrimary: false,
    phone: "",
    address: "",
    postCode: "",
    city: "",
    country: "",
    description: "",
    createdAt: "",
    useremploymentinformationSet: [],
};

export const CompanyAddressEmpty: CompanyAddressType = {
    id: ID_EMPTY,
    company: CompanyEmpty,
    isPrimary: false,
    phone: "",
    address: "",
    postCode: "",
    city: "",
    country: "",
    description: "",
    createdAt: "",
    useremploymentinformationSet: [],
};

export const ProfileEmpty: ProfileType = {
    id: ID_EMPTY,
    name: "",
    customer: undefined,
    permissions: [],
    corporate: false,
    anyCompany: false,
    anyCustomer: false,
    rolecompanySet: [],
    rolecorporateSet: [],
    rolecustomerSet: [],
    createdAt: "",
    directChildProfiles: [],
};

export const FunctionalityEmpty: Functionality = {
    companies: [],
    customers: [],
    isHealthcareWorker: false,
    isSupplier: false,
    language: "fi",
    perms: [],
    primaryUi: ViewViewTypeChoices.Customeradmin,
    showCorporateAdminViews: false,
    showCustomerAdminViews: false,
    showHealthcareWorkerViews: false,
    showRegionalAdminViews: false,
    showSupplierViews: false,
};

export const LaboratorySupplierEmpty: LaboratorySupplierType = {
    id: ID_EMPTY,
    name: "",
    city: "",
    address: "",
    postCode: "",
    phoneNumber: "",
    discountPercent: "",
    pricePerVisit: "",
    createdAt: "",
    childLaboratories: [],
    code: {
        abbreviation: "",
        address: "",
        beginDate: "",
        city: "",
        expirationDate: "",
        hierarchyLevel: "",
        parentId: "",
        phoneNumber: "",
        postCode: "",
        codeId: ID_EMPTY,
        id: ID_EMPTY,
        laboratorysupplierSet: [],
        businessId: "",
    },
    supplierpackagepriceSet: [],
    suppliertestpriceSet: [],
    updatedAt: "",
};

export const CampaignEmpty: CampaignType = {
    id: ID_EMPTY,
    name: "",
    documentTemplates: [],
    surveys: [],
    createdAt: "",
};

export const DocumentCategoryEmpty: DocumentCategoryType = {
    id: ID_EMPTY,
    company: CompanyEmpty,
    type: DocumentsDocumentCategoryTypeChoices.Upload,
    title: "",
    description: "",
    hideOldVersions: false,
    showForCustomers: false,
    showForCustomerUsers: false,
    documentSet: [],
    documentcategorySet: [],
    createdAt: "",
};

export const DocumentEmpty: DocumentType = {
    id: ID_EMPTY,
    customer: CustomerEmpty,
    documentCategory: DocumentCategoryEmpty,
    title: "",
    documentversionSet: [],
    createdAt: "",
};

export const DocumentVersionEmpty: DocumentVersionType = {
    id: ID_EMPTY,
    document: DocumentEmpty,
    createdBy: UserEmpty,
    versionNumber: 0,
    file: "",
    fileThumbnail: "",
    createdAt: "",
};

export const InvoiceInterfaceEmpty: InvoiceInterfaceType = {
    id: ID_EMPTY,
    company: CompanyEmpty,
    apiKey: "",
    apiUser: "",
    createdAt: "",
};

export const ViewEmpty: ViewType = {
    id: ID_EMPTY,
    title: "",
    viewType: ViewsViewViewTypeChoices.Customeradmin,
    permissions: [],
    users: [],
    createdAt: "",
};

export const ProfessionalGroupEmpty: ProfessionalGroupType = {
    id: ID_EMPTY,
    title: "",
    userSet: [],
    createdAt: "",
    taskSet: [],
};

export const SalesCatalogEmpty: SalesCatalogType = {
    id: ID_EMPTY,
    name: "",
    state: SalescatalogsSalesCatalogStateChoices.Draft,
    createdAt: "",
    salesPrices: [],
};

export const ContactPersonEmpty: ContactPersonType = {
    id: ID_EMPTY,
    lastName: "",
    firstName: "",
    email: "",
    phoneNumber: "",
    contactType: OrganizationsContactPersonContactTypeChoices.Contract,
    customer: CustomerEmpty,
};

export const InsuranceCompanyEmpty: InsuranceCompanyType = {
    id: ID_EMPTY,
    name: "",
    businessId: "",
    phoneNumber: "",
    instructions: "",
    insuranceSet: [],
};

export const InsuranceEmpty: InsuranceType = {
    id: ID_EMPTY,
    insuranceCompany: InsuranceCompanyEmpty,
    insuranceType: InsurancesInsuranceInsuranceTypeChoices.Accident,
    insuranceNumber: "",
    description: "",
    instructions: "",
    url: "",
};

export const NodeEmpty: NodeType = {
    id: ID_EMPTY,
    shorthand: "",
    title: "",
    questionOverride: "",
    tag: "",
    question: null,
    link: null,
    groups: [],
    links: [],
    nextBranches: [],
};

export const QuestionEmpty: QuestionType = {
    id: ID_EMPTY,
    name: "",
    question: "",
    answerType: QuestionsQuestionAnswerTypeChoices.Text,
    textInfo: "",
    textHelp: "",
    key: null,
    mandatory: true,
    answerChoices: [],
    matrixQuestions: [],
    matrixQuestionFactors: [],
    settingsReady: false,
    answerScores: [],
    answerLimitMinimum: null,
    answerLimitMaximum: null,
    isSlider: false,
    sliderStep: 1.0,
    answerMultiplier: 1.0,
    nodes: [],
    createdAt: "",
};

export const NodeGroupEmpty: NodeGroupType = {
    id: ID_EMPTY,
    label: "",
    tag: "",
    nodes: [],
};

export const FitnessTestDeviceEmpty: FitnessTestDeviceType = {
    id: ID_EMPTY,
    name: "",
    deviceType: FitnesstestsFitnessTestDeviceDeviceTypeChoices.FitnessTest,
    isDefault: false,
    createdAt: "",
};

export const CostCenterEmpty: CostCenterType = {
    id: ID_EMPTY,
    company: null,
    customer: null,
    name: "",
    remoteId: "",
    userSet: [],
    costCenterInvoiceRows: [],
};

export const HealthCheckConfigurationEmpty: HealthCheckConfigurationType = {
    id: ID_EMPTY,
    checkType: HealthCheckTypeChoices.Initial,
    intervalYears: null,
    appliesBeforeAge: null,
    appliesAfterAge: null,
    triggerAge: null,
    laboratoryTestsSynlab: "",
    laboratoryTestsNordlab: "",
    laboratory: LaboratoryChoices.Both,
    useSameTestsForBoth: false,
    reasonOrGoal: "",
    contentDescription: "",
    checkupType: CheckupTypeChoices.Nurse,
    checkupLength: CheckupLengthChoices.Min_30,
    zefQuestionnaireLink: null,
    displayOrder: 0,
    exposure: {} as ExposureType, // Circular reference, will be set by parent
};

export const ExposureEmpty: ExposureType = {
    id: ID_EMPTY,
    name: "",
    description: "",
    healthCheckConfigs: [],
    createdAt: "",
    updatedAt: "",
};
